var _circle, _line, _line2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuAddMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.65384,
    cy: 11.5,
    r: 7.5,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.40384,
    y1: 11.5,
    x2: 11.2788,
    y2: 11.5,
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.40384,
    y1: 13.375,
    x2: 9.40384,
    y2: 9.5,
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5288 15.375C14.2781 17.5047 12.3153 18.75 9.63772 18.75C5.64256 18.75 2.40384 15.56 2.40384 11.625C2.40384 7.68997 5.64256 4.5 9.63772 4.5C10.8334 4.5 11.9614 4.78574 12.955 5.29167",
    stroke: "#525D71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0522 4.95376C12.9638 4.99524 12.9052 5.09892 12.9052 5.20565C12.9046 5.31177 12.9621 5.41179 13.0506 5.45388C14.3952 6.09609 15.0764 7.2244 15.4175 8.40454C15.4922 8.66192 15.4513 8.89124 15.307 9.10897C15.1621 9.32731 14.9321 9.40355 14.6877 9.40355L13.4653 9.40355C13.2623 9.40355 13.0755 9.6408 12.9765 9.83474C12.8759 10.0299 12.8803 10.3574 12.9865 10.5495L16.9253 17.6993C17.027 17.8841 17.2089 18 17.4041 18C17.5998 18 17.7817 17.8853 17.8834 17.7012L21.8223 10.5459C21.9273 10.355 21.9312 10.0311 21.8322 9.83596C21.7327 9.64202 21.5458 9.40355 21.3429 9.40355L20.0154 9.40355C19.609 9.40355 19.264 9.13214 19.1977 8.68875C18.8543 6.35896 17.0414 4.5 14.8541 4.5C14.351 4.5 13.6532 4.6726 13.0522 4.95376Z",
    fill: "white",
    stroke: "#525D71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuAddMoney);
export default __webpack_public_path__ + "static/media/ic-menu-add-money.ad370fb846ce9c409c3d9e19f3e89aff.svg";
export { ForwardRef as ReactComponent };